import React from 'react';


export const EndEvent = React.memo(() => {
    return (
        <div className="end">
            <div className="content"></div>
        </div>
    );
});
